<script setup>
import { reactive } from "vue";

const props = defineProps({
    defaultOpen: {
        type: Boolean,
        default: true,
    },
    cancellable: {
        type: Boolean,
        default: true,
    },
});
const state = reactive({
    open: props.defaultOpen,
});
function shouldShowTrigger() {
    if (props.cancellable) {
        return true;
    }
    if (!state.open) {
        return true;
    }
}
</script>

<template>
    <div
        @click="state.open = !state.open"
        class="cursor-pointer my-4"
        v-if="shouldShowTrigger()"
    >
        <slot name="trigger" :open="state.open"></slot>
    </div>
    <div v-if="state.open" class="fade-in">
        <slot></slot>
    </div>
</template>

<style scoped>
@keyframes fadeIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}
.fade-in {
    animation: fadeIn 0.3s ease-in-out;
}
</style>
